import { render } from "./AboutModal.vue?vue&type=template&id=500a0bbb&scoped=true"
const script = {}

import "./AboutModal.vue?vue&type=style&index=0&id=500a0bbb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-500a0bbb"]])

export default __exports__